import { Button, UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';
import { CardSectionNew } from 'shared/components/CardSectionNew';
import { TNewbuildingBrokerFlatBannerButtonType } from 'shared/components/NewbuildingBrokerFlatBanner';
import { NBSP } from 'shared/constants';

import * as styles from './NewbuildingBrokerFlatBannerRedesign.css';
import cardUrl from './assets/card.svg';

interface INewbuildingBrokerFlatBannerRedesignProps {
  onButtonClick: (buttonType: TNewbuildingBrokerFlatBannerButtonType) => void;
}

export const NewbuildingBrokerFlatBannerRedesign: React.FC<INewbuildingBrokerFlatBannerRedesignProps> = ({
  onButtonClick,
}) => {
  const handleSimilarButtonClick = React.useCallback(() => {
    onButtonClick('similar');
  }, [onButtonClick]);

  const handleNotSimilarButtonClick = React.useCallback(() => {
    onButtonClick('notSimilar');
  }, [onButtonClick]);

  return (
    <CardSectionNew hideForPrint data-testid="NewbuildingBrokerFlatBanner">
      <div className={styles['container']}>
        <div className={styles['content']}>
          <img loading="lazy" aria-hidden="true" className={styles['preview']} src={cardUrl} alt="" />
          <UIHeading2 color="text-primary-default">
            Похоже на{NBSP}то, что{NBSP}вы ищете?
          </UIHeading2>
          <div className={styles['actions']}>
            <div className={styles['action']}>
              <Button fullWidth size="M" theme="inverted" onClick={handleSimilarButtonClick}>
                Да
              </Button>
            </div>
            <div className={styles['action']}>
              <Button fullWidth size="M" theme="inverted" onClick={handleNotSimilarButtonClick}>
                Нет
              </Button>
            </div>
          </div>
        </div>
      </div>
    </CardSectionNew>
  );
};
